import { useCallback } from 'react';
import { getPromptingStructure } from '../helpers/prompting';

export const useResetDataPoints = (setDataPoints) =>
  useCallback(
    (promptingType) => {
      setDataPoints([
        {
          frequency: '',
          duration: '',
          severity: '',
          intensity: '',
          accuracy: '',
          independence: '',
          yesNo: '',
          selectedOptions: [],
          abcData: {
            antecedent: '',
            behavior: '',
            consequence: '',
            setting: '',
            notes: '',
          },
          settingLocation: '',
          phaseChange: '',
          eventLine: '',
          timeOfCollection: '',
          timeOfCollectionSpecific: '',
          notes: '',
          prompting: getPromptingStructure(promptingType),
          currentGoal: '',
          currentTime: new Date().toISOString(),
          additionalStaff: false,
          numberOfStaffs: 0,
          promptingLevel: '',
        },
      ]);
    },
    [setDataPoints]
  );

export default useResetDataPoints;


